import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Stack, Textarea } from "@mantine/core";
import { AppModal } from "./AppModal";
import { useForm, yupResolver } from "@mantine/form";
import { CharacterLimit } from "../enums/CharacterLimit";
import { useCreateHelpRequestMutation } from "../graphql/graphql";
import { showErrorNotification, showSuccessNotification } from "./Notifications";
import { HelpRequestInitialValues, HelpRequestSchema } from "./HelpRequestModal.validation";
export const HelpRequestModal = ({ opened, close }) => {
    const [{ fetching: submittingHelpRequest }, createHelpRequest] = useCreateHelpRequestMutation();
    // Form Data
    const form = useForm({
        mode: "controlled",
        initialValues: HelpRequestInitialValues,
        validate: yupResolver(HelpRequestSchema)
    });
    // Sends the help request
    const submitHelpRequest = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        // Sends the help request
        createHelpRequest({ message: form.values.message })
            .then(() => {
            showSuccessNotification("Help request submitted!");
        })
            .catch((error) => {
            console.error("An error occurred.", error);
            showErrorNotification("Failed to submit help request.... which is actually ironic...");
        })
            .finally(() => {
            handleClose();
        });
    };
    const handleClose = () => {
        close();
        form.reset();
    };
    return (_jsx(AppModal, { title: "Submit Help Request", opened: opened, onClose: handleClose, children: _jsxs(Stack, { gap: "md", children: [_jsx(Textarea, { label: "Help Request", placeholder: "Please describe what you need help with... \n\n" +
                        "Please include details about what you're trying to accomplish, any specific questions you have, and any other relevant information that would help us assist you.", autosize: true, minRows: 4, maxRows: 20, maxLength: CharacterLimit.HELP_REQUEST, ...form.getInputProps("message") }), _jsxs(Flex, { justify: "space-between", children: [_jsx("div", { style: {
                                color: "grey",
                                paddingLeft: "0.25rem",
                                fontSize: 12
                            }, children: `${form.values.message.length} / ${CharacterLimit.HELP_REQUEST}` }), _jsx(Button, { variant: "filled", loading: submittingHelpRequest, onClick: submitHelpRequest, children: "Submit" })] })] }) }));
};
